<template>
  <ListagemBase
    nomePlural="FuncionarioAfastamentoTipos"
    nomeSingular="FuncionarioAfastamentoTipo"
    :headers="headers"
    atualizarDadosAoEditar
    recarregarDadosAoEditar
  >
    <template v-slot:item.limitesAfastamento="{ item }">
      <div v-if="limitesAtivos(item).length" class="d-flex flex-wrap">
        <v-chip
          v-for="limite in limitesAtivos(item)"
          :key="limite.label"
          x-small
          outlined
          class="mr-1 my-1"
        >
          {{ $t(limite.label) }}: {{ limite.valor }}
        </v-chip>
      </div>
      <span v-else>—</span>
    </template>
  </ListagemBase>
</template>

<script>
import DataService from "@/services/pessoal/FuncionarioAfastamentoTipoDataService";
import ListagemBase from "@/components/base/Crud/ListagemBase";

export default {
  name: "ListagemFuncionarioAfastamentoTipos",
  components: { ListagemBase },
  data() {
    return {
      DataService,
      headers: [
        { text: this.$t("Descricao"), value: "descricao", sortable: "false" },
        {
          text: this.$t("codigoExterno"),
          value: "codigoExterno",
          sortable: "false",
        },
        { text: this.$t("Tipo"), value: "tipo", sortable: "false" },
        {
          text: this.$t("disponivelApp"),
          value: "disponivelApp",
          sortable: "false",
        },
        {
          text: this.$t("opcaoSupervisor"),
          value: "opcaoSupervisor",
          sortable: "false",
        },
        {
          text: this.$t("limitesAfastamento"),
          value: "limitesAfastamento",
          sortable: false,
        },
        { text: this.$t("Status"), value: "statusComum", sortable: "false" },
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: "false",
        },
        {
          text: this.$t("Data_de_inclusao"),
          value: "dtInclusao",
          sortable: "false",
        },
        {
          text: this.$t("Data_de_alteracao"),
          value: "dtAlteracao",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    limitesAtivos(item) {
      return [
        [
          "limitarRegistrosSemana",
          "quantidadeLimiteRegistrosSemana",
          "limiteSemanaCurto",
        ],
        [
          "limitarRegistrosMes",
          "quantidadeLimiteRegistrosMes",
          "limiteMesCurto",
        ],
        [
          "limitarRegistrosPeriodo",
          "quantidadeLimiteRegistrosPeriodo",
          "limitePeriodoPontoCurto",
        ],
        [
          "limitarRegistrosSemestre",
          "quantidadeLimiteRegistrosSemestre",
          "limiteSemestreCurto",
        ],
        [
          "limitarRegistrosAno",
          "quantidadeLimiteRegistrosAno",
          "limiteAnoCurto",
        ],
      ]
        .filter(([ativo, quantidade]) => item[ativo] && item[quantidade] > 0)
        .map(([, quantidade, label]) => ({ label, valor: item[quantidade] }));
    },
  },
};
</script>

<style></style>
